import { Call, ApiUrl, ParseGeneralResponse, getUrlWithPagination } from './ApiUtils';

export const getCompanyVendorProfile = (id, additionalParams) => {
  const url = ApiUrl(`/global/vendor_profiles/${id}?${additionalParams}`);

  return Call('get', url, {}, ParseGeneralResponse, {
    responseDataKeys: { vendor_profile: 'vendor_profile' },
  });
};

/**
 * @param {import('types').ID} id
 * @param {string} [additionalParams]
 * @returns {Promise<{ success: boolean, vendor_organization: import('types').VendorOrganization }>}
 */
export const getCompanyVendorOrganizationProfile = (id, additionalParams) => {
  let url = ApiUrl(`/global/vendor_organizations/${id}`);

  if (additionalParams) {
    url += `?${additionalParams}`;
  }

  return Call('get', url, {}, ParseGeneralResponse, {
    responseDataKeys: { vendor_organization: 'vendor_organization' },
  });
};

export function getAllVendorOrgsList () {
  const url = ApiUrl('/global/all_vendor_org_list');

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        company_vendor_orgs: 'all_vendor_orgs'
      },
    },
  );
}

export function updateVendorProfile (data, isFreeEmail) {
  const url = ApiUrl('/vendor_profile_db');

  return Call(
    'post',
    url,
    {
      email: data.email,
      first_name: data.firstName,
      id: data.vendorOrgId,
      is_free_email: isFreeEmail,
      job_title: data.jobTitle,
      last_name: data.lastName,
      phone: data.phone
    },
    ParseGeneralResponse,
    {
      responseDataKeys: {
        vendor_profile: 'vendor_profile'
      },
    },
  );
}

export function updateVendorProfileDetails (data) {
  const url = ApiUrl('/global/update_vendor_profile_details');

  return Call(
    'post',
    url,
    {
      email: data.email,
      id: data.detailsId,
      notes: data.notes,
    },
    ParseGeneralResponse,
    {
      responseDataKeys: {
        vendor_profile: 'vendor_profile'
      },
    },
  );
}
export function updateVendorOrgDetails (data) {
  const url = ApiUrl('/global/update_vendor_org_details');

  return Call(
    'post',
    url,
    {
      id: data.detailsId,
      notes: data.notes,
      vendor_organization_id: data.vendorOrgId,
    },
    ParseGeneralResponse,
    {
      responseDataKeys: {
        vendor_organization: 'vendor_organization'
      },
    },
  );
}

/**
 * @typedef {Omit<import('types').Address, 'id'> & { id?: import('types').ID }} VendorOrgAddressInput
 *
 * @param {{
 *   addresses?: VendorOrgAddressInput[],
 *   categorizationCodes?: string[],
 *   city?: string,
 *   country?: string,
 *   countryCode?: string,
 *   description?: string,
 *   domains?: string[],
 *   email?: string,
 *   name?: string,
 *   numOfEmployees?: string,
 *   phone?: string,
 *   publicListed?: boolean,
 *   state?: string,
 *   stateCode?: string,
 *   tags?: string[],
 *   vendorOrgId: import('types').ID,
 *   website?: string,
 * }} data
 * @returns {Promise<{
 *   errors?: Record<string, string[]> | string[],
 *   success: boolean,
 *   vendor_organization?: import('types').VendorOrganization,
 * }>}
 */
export function updateVendorOrganization (data) {
  const url = ApiUrl('/global/update_vendor_organization');

  return Call(
    'post',
    url,
    {
      addresses: data.addresses,
      categorization_codes: data.categorizationCodes,
      city: data.city,
      country: data.country,
      country_code: data.countryCode,
      description: data.description,
      domains: data.domains,
      email: data.email,
      id: data.vendorOrgId,
      name: data.name,
      num_of_employees: data.numOfEmployees,
      phone: data.phone,
      public_listed: data.publicListed,
      state: data.state,
      state_code: data.stateCode,
      tags: data.tags,
      website: data.website,
    },
    ParseGeneralResponse,
    {
      responseDataKeys: {
        vendor_organization: 'vendor_organization'
      },
    },
  );
}

export function getVendorOrgRequestInfo (
  id,
  current,
  pageSize,
  sortField,
  sortOrder,
  filters,
  limit
) {

  const basePath = '/global/vendor_org_requests_info';
  const requiredArgs = `id=${id}`;

  let url = getUrlWithPagination(basePath, requiredArgs, current, pageSize, sortField, sortOrder, filters);

  if (limit) url += `&limit=${limit}`;

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        average_engagement_score: 'average_engagement_score',
        pagination: 'pagy',
        requests_info: 'requests_info'
      },
    },
  );
}

export function getVendorRequestInfo (
  email,
  current,
  pageSize,
  sortFields,
  sortOrder,
  filters
) {

  const basePath = '/global/vendor_requests_info';
  const requiredArgs = `email=${email}`;

  const url = getUrlWithPagination(basePath, requiredArgs, current, pageSize, sortFields, sortOrder, filters);

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        pagination: 'pagy',
        requests_info: 'requests_info',
      },
    },
  );
}
